<template>
  <v-card>
    <v-card-title style="background-color: #004056" class="white--text">
      Decline this Lead?
    </v-card-title>

    <v-divider />

    <v-card-text class="mt-4">
      <v-radio-group v-model="declineParams" mandatory>
        <v-radio :value="{}" >
          <template #label >
            <div class="pl-2">
              <div class="font-weight-bold">
                I'm too busy right now.
              </div>
              <div class="mt-1">
                That's ok, we'll send you more leads later.
              </div>
            </div>
          </template>
        </v-radio>

        <v-radio :value="{ block_service: true }" class="mt-5">
          <template #label>
            <div class="pl-2">
              <div class="font-weight-bold">
                I don't do <span class="green--text">{{ lead.service }}</span> jobs.
              </div>
              <div class="mt-1">
                Ok, we won't send you any more {{ lead.service }} jobs.
              </div>
            </div>
          </template>
        </v-radio>

        <v-radio :value="{ block_structure_type: true }" class="mt-5">
          <template #label>
            <div class="pl-2">
              <div class="font-weight-bold">
                I don't do <span class="green--text">{{ lead.friendly_structure_type }}</span> work.
              </div>
              <div class="mt-1">
                Ok, we won't send you any more {{ lead.friendly_structure_type }} work.
              </div>
            </div>
          </template>
        </v-radio>
      </v-radio-group>
    </v-card-text>

    <v-divider />

    <v-card-actions class="justify-center py-3 px-8">
      <v-btn @click="$emit('back')">Back</v-btn>
      <v-btn color="primary" @click="declineClick">Decline</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'DeclineLeadCard',

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    declineParams: {},
  }),

  methods: {
    ...mapActions('leads', ['declineLead']),

    async declineClick() {
      const { lead_id } = this.lead

      const payload = { ...this.declineParams, lead_id }
      await this.declineLead(payload)
      this.$router.go()
    }
  }
}
</script>